module.exports = __webpack_public_path__ + "static/media/testimonial-b.b71f679a.png";